export default __webpack_public_path__ + "static/media/skoda-signup.f843f9b7.jpg";